import { ACTION_TYPES } from "../../actions/maintenance/MaintenanceActions"

const initialState = {
    list: [],
    listOrders: [],
    evidence: [],
    orderDetail: {},
    historyList: [],
    resultInvoice: {},
    resultComplement: {},
    listInvoicesComplement: {},
    listRejectedInvoices: []
}
export const MaintenanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                list: [],
                listOrders: [],
                evidence: [],
                orderDetail: {},
                historyList: [],
                resultInvoice: {},
                resultComplement: {},
                listInvoicesComplement: {},
                listRejectedInvoices: []
            }
        case ACTION_TYPES.FETCH_DASHBOARD:
            return {
                ...state,
                list: [...action.payload]
            }
        case ACTION_TYPES.FETCH_OC_BY_STATUS:
            return {
                ...state,
                listOrders: [...action.payload]
            }
        case ACTION_TYPES.FETCH_ORDER_DETAIL_MAINTENANCE:
            return {
                ...state,
                orderDetail: action.payload
            }
        case ACTION_TYPES.FETCH_EVIDENCE:
            return {
                ...state,
                evidence: [...action.payload]
            }
        case ACTION_TYPES.FETCH_INVOICE_HISTORY:
            return {
                ...state,
                historyList: [...action.payload]
            }
        case ACTION_TYPES.RESULT_UPLOAD_INVOICE:
            return {
                ...state,
                resultInvoice: action.payload
            }
        case ACTION_TYPES.RESULT_UPLOAD_MARKUP_INVOICE:
            return {
                ...state,
                resultMarkupInvoice: action.payload
            }
        case ACTION_TYPES.RESULT_UPLOAD_COMPLEMENT:
            return {
                ...state,
                resultComplement: action.payload
            }
        case ACTION_TYPES.FETCH_INVOICE_COMPLEMENT:
            return {
                ...state,
                listInvoicesComplement: action.payload
            }
        case ACTION_TYPES.FETCH_REJECTED_INVOICE:
            return {
                ...state,
                listRejectedInvoices: [...action.payload]
            }
        default:
            return state
    }
}